module.exports = __webpack_public_path__ + "static/img/home-top9.8a39d2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home-top9.png
// module id = Npqf
// module chunks = 21